import React from 'react';
import type { BoxDimensions } from '../parseBoxDimensions';

export function formatBoxDimensionToken(value: number): string {
  return String(value);
}

export function boxDimensionConfirmMessage(dims: BoxDimensions, orderNumber: string): string {
  const size = [dims.length, dims.width, dims.height].map(formatBoxDimensionToken).join('x');
  return `Set box size to ${size} for order ${orderNumber}?`;
}

interface BoxDimensionConfirmModalProps {
  readonly message: string;
  readonly saving: boolean;
  readonly onConfirm: () => void;
  readonly onCancel: () => void;
}

function BoxDimensionConfirmModal({
  message,
  saving,
  onConfirm,
  onCancel,
}: BoxDimensionConfirmModalProps): React.ReactElement {
  return (
    <div className="order-detail-check-slack-overlay box-dimension-confirm-overlay" role="dialog" aria-modal="true" aria-labelledby="box-dimension-confirm-title">
      <div className="order-detail-check-slack-dialog">
        <p id="box-dimension-confirm-title" className="order-detail-check-slack-message">
          {message}
        </p>
        <button
          type="button"
          className="order-detail-check-slack-btn"
          onClick={onConfirm}
          disabled={saving}
        >
          {saving ? 'Saving…' : 'Confirm'}
        </button>
        <button
          type="button"
          className="order-detail-release-cancel-btn box-dimension-confirm-cancel"
          onClick={onCancel}
          disabled={saving}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default BoxDimensionConfirmModal;
